import React from "react"

import { Swiper, SwiperSlide } from "swiper/react"
import Skeleton from "react-loading-skeleton"
import "react-loading-skeleton/dist/skeleton.css"

const AdminOffersCardsSk = () => {
  const count = 5
  return (
    <React.Fragment>
      <div className="icd-card-wrapper-section">
        <Swiper
          spaceBetween={20}
          navigation={false}
          // pagination={{ clickable: false }}
          loop={false}
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 1 },
            1024: { slidesPerView: 1.7 },
            1400: { slidesPerView: 2 },
          }}
        >
          {Array(count)
            .fill()
            .map((_, index) => (
              <SwiperSlide key={`admin_icds_sk_${index}`}>
                <Skeleton
                  style={{
                    minHeight: "230px",
                    borderRadius: "20px",
                  }}
                />
              </SwiperSlide>
            ))}
          {/* <SwiperSlide>
            <div className="icd-card-box-second">
              <div className="logo-section-wrapper">
                <div className="logo-image">
                  <img src={logoIcon} alt="" />
                </div>
                <h4>ICD-2025-2735</h4>
              </div>
              <h5>₹1,00,00,000</h5>
              <div>
                <ProgressBar
                  borderRadius="8px"
                  height="8px"
                  baseBgColor="#B3B3B333"
                  bgColor="#1667AD"
                  completed={60}
                  isLabelVisible={false}
                />
              </div>
              <div className="amount-wrapper">
                <div className="left-box">
                  <p>
                    Total Amt <span>₹ 10,00,00,000</span>
                  </p>
                  <p>
                    ROI <span>12% p.a</span>
                  </p>
                </div>
                <div className="right-box">
                  <p>
                    Req. Amt <span>₹ 9,00,00,000</span>
                  </p>
                  <p>
                    Tenure <span>180 Days</span>
                  </p>
                </div>
              </div>
            </div>
          </SwiperSlide> */}
        </Swiper>
      </div>
    </React.Fragment>
  )
}

export default AdminOffersCardsSk
